import { Component, HostListener, Inject, OnDestroy, PLATFORM_ID, Renderer2 } from '@angular/core';
import { MetaMgmtService } from '../../../shared/services/meta-mgmt.service';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { EshopService } from '../../../shared/services/eshop.service';
import { DataLayerService } from '../../../shared/services/gtm-service/data-layer.service';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SchemaService } from '../../../shared/services/schema.service';
import { CarousalPageComponent } from '../../../shared/components/carousal-page/carousal-page.component';
import { HelpSupportComponent } from '../../../shared/components/help-support/help-support.component';
import { InputformsComponent } from '../../../shared/components/inputforms/inputforms.component';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-eshop-home',
  standalone: true,
  imports: [CommonModule,CarousalPageComponent,CarouselModule,HelpSupportComponent,InputformsComponent],
  templateUrl: './eshop-home.component.html',
  styleUrl: './eshop-home.component.scss'
})
export class EshopHomeComponent implements OnDestroy {
  environment: any = environment;
  public eshopHomeData: any;
  mobileBannerList: any = [];
  webBannerList: any = [];
  halfBannerSection: any = [];
  sub:Subscription=new Subscription()
  hotOffersSection: any = {};
  topDealsSection: any = {}
  topDealsSectiontwo: any = {};
  productCarousalData!: any[];
  categoryCarousalData!: any[];
  autoplay: boolean=true;

  script:any;
  actualSchemaValue:any;
  constructor(    @Inject(PLATFORM_ID) private platformId: Object,
  private _renderer2: Renderer2,
  @Inject(DOCUMENT) private _document: Document,
  private schemaService: SchemaService,
  public utils: UtilsService, public analyticsService: AnalyticsService, private eshopSvc: EshopService, private metaSvc: MetaMgmtService, private _dataLayerService: DataLayerService) {
    this.utils.showHeaderFooter.next(true);
    this.utils.showLoading();
    this.sub.add(this.eshopSvc.getEshopHomePageData().subscribe({
      next: (response: any) => {
        this.utils.hideLoading();
        if (response.success) {
          this.eshopHomeData = response;
          this.processData();
        }
        else {
          this.utils.openSnackBar(response.message, 'error-toster');
          this.utils.backToRoot();
          this.utils.hideLoading();
        }
      }
    }))

    this.callSchema();
  }
  async callSchema(){
    this.actualSchemaValue = await this.schemaService.addSchema();
    this.script  = this._renderer2.createElement('script');
    this.script.type = `application/ld+json`;
    this.script.text = JSON.stringify(this.actualSchemaValue);
    this.script.defer = true;
    this._renderer2.appendChild(this._document.body, this.script);
  }

  ngOnInit(): void {
  }
  @HostListener('window:scroll')
  onWindowScroll() {
    this.updateAutoplay();
  }

  updateAutoplay() {
    const isBannerVisible = this.utils.isElementVisible('caraousel-scroll');
    if (!isBannerVisible) {
      this.autoplay = false;
    } else {
      this.autoplay = true;
    }
  }

  triggerPromotionEventsIfListExists(bannerList: any) {
    if (bannerList && bannerList.length > 0) {
      this._dataLayerService.triggerPromotionEvents(bannerList, 'view_promotion');
    }
  }

  triggerBannerClick(bannerData: any) {
    this._dataLayerService.triggerPromotionEvents(bannerData, 'select_promotion');
  }


  handleSlideChange(event: any, type: string) {
    let currentSlideData: any;
    let slideList: any[];
    if (this.autoplay) {
    if (type === 'web') {
      currentSlideData = this.webBannerList[event.startPosition];
      slideList = this.webBannerList;
    } else if (type === 'mob') {
      currentSlideData = this.mobileBannerList[event.startPosition];
      slideList = this.mobileBannerList;
    }
    currentSlideData.creativeSlot = event.startPosition + 1;
    this.triggerPromotionEventsIfListExists([currentSlideData]);
  }
  }



  processData() {
    if (this.eshopHomeData && this.eshopHomeData.mainBanner && this.eshopHomeData.mainBanner.length) {
      this.mobileBannerList = [];
      this.webBannerList = [];
      this.eshopHomeData.mainBanner.forEach((element: any) => {
        let mobileBanner = {
          image: element.mobileImageFile,
          link: element.ctaLink,
          altTag: element.altTag,
          guidId: element.guidId,
          isSmallBanner: element.isSmallBanner,
          filename: element.mobileImageFileName
        }
        let webBanner = {
          image: element.webImageFile,
          link: element.ctaLink,
          altTag: element.altTag,
          guidId: element.guidId,
          isSmallBanner: element.isSmallBanner,
          filename: element.webImageFileName
        }
        if (!element.isSmallBanner) {
          this.webBannerList.push(webBanner);
          this.mobileBannerList.push(mobileBanner);
        }
      });
      if (this.webBannerList && this.webBannerList.length > 1) {
        this.utils.customOptionsForBanner.loop = true;
      }

    }
    if (this.eshopHomeData && this.eshopHomeData.banner && this.eshopHomeData.banner.length) {
      this.halfBannerSection = [];
      this.eshopHomeData.banner.forEach((element: any) => {
        let webBanner = {
          image: element.webImageFile,
          link: element.ctaLink,
          altTag: element.altTag,
          guidId: element.guidId,
          isSmallBanner: element.isSmallBanner,
          filename: element.webImageFileName
        }
        if (!element.isSmallBanner) {
          this.halfBannerSection.push(webBanner);
        }
      });
      if (this.halfBannerSection && this.halfBannerSection.length > 2) {
        this.utils.optionForBannerArea.loop = true;
      }

    }
    if (this.eshopHomeData && this.eshopHomeData.heading1 && this.eshopHomeData.heading1.name) {
      this.hotOffersSection['name'
      ] = this.eshopHomeData.heading1.name;
      if (this.eshopHomeData.heading1.banner && this.eshopHomeData.heading1.banner.length)
        this.hotOffersSection['banner'
        ] = this.getBannerFileForOffersSection(this.eshopHomeData.heading1.banner)
    }
    if (this.eshopHomeData && this.eshopHomeData.heading2 && this.eshopHomeData.heading2.name) {
      this.topDealsSection['name'
      ] = this.eshopHomeData.heading2.name;
      if (this.eshopHomeData.heading2.banner && this.eshopHomeData.heading2.banner.length)
        this.topDealsSection['banner'
        ] = this.getBannerFileForOffersSection(this.eshopHomeData.heading2.banner)
    }
    if (this.eshopHomeData && this.eshopHomeData.heading3 && this.eshopHomeData.heading3.name) {
      this.topDealsSectiontwo['name'
      ] = this.eshopHomeData.heading3.name;
      if (this.eshopHomeData.heading3.banner && this.eshopHomeData.heading3.banner.length)
        this.topDealsSectiontwo['banner'
        ] = this.getBannerFileForOffersSection(this.eshopHomeData.heading3.banner)
    }
    if (this.eshopHomeData && this.eshopHomeData.productResponseList && this.eshopHomeData.productResponseList.length) {
      this.productCarousalData = [];
      this.eshopHomeData.productResponseList.forEach((element: any) => {
        let obj = {
          image: element.featureImageUrl,
          description: element.productName,
          price: element.productMRP ? element.productMRP : '0',
          altTag: element.featureImageAltTag,
          productGuid: element.productGuidId,
          productName: element.productName
        }
        this.productCarousalData.push(obj);
      });
      this.triggerViewListEvent();
    }
    if (this.eshopHomeData && this.eshopHomeData.eShopCategoryList && this.eshopHomeData.eShopCategoryList.length) {
      this.categoryCarousalData = [];
      this.eshopHomeData.eShopCategoryList.forEach((element: any) => {
        let obj = {
          image: element.featureImageUrl,
          description: element.categoryName,
          price: element.productMRP ? element.productMRP : '0',
          altTag: element.altTag,
          isProductNot: element.productMRP ? false : true,
          productGuid: element.eshopCategoryGuidId
        }
        this.categoryCarousalData.push(obj);
      });
    }
    this.metaSvc.updateMetaTags(this.eshopHomeData.metaInfoResponse);
    this.utils.hideLoading();
  }

  triggerViewListEvent() {
    let itemArray = this.eshopHomeData.productResponseList.map((data: any, index: number) => {
      return {

        item_id: data?.productSKU || '',
        item_name: data?.productName || '',
        item_brand: data?.subCat || data?.eshopCat || 'NA',
        currency: 'INR',
        discount: data.productDiscountedPrice !== 0 ? (data.productPrice - data.productDiscountedPrice) : 0,
        item_category: data?.eshopCat || '',
        item_category2: data?.subCat || '',
        item_category4: (data?.specificationList?.length)
          ? (data.specificationList.find((element: any) => element.description === 'VA Rating')?.value || 'NA')
          : 'NA',

        item_category5: (data?.specificationList?.length)
          ? (data.specificationList.find((element: any) => element.description === 'Technology')?.value || 'NA')
          : 'NA',
        price: data.productDiscountedPrice !== 0 ? data.productDiscountedPrice : data.productPrice,
        item_list_name: 'Our products',
        item_list_id: 'our_products',
        item_variant:
          (data && data?.specificationList?.length) ? data.specificationList.find(
            (element: any) => element.description == 'Warranty'
          )?.value : 'NA',
      };
    });
    this._dataLayerService.triggerEvents(itemArray, 'view_item_list');
  }



  getBannerFileForOffersSection(arrayToProcess: any) {
    let bannerList: any = [];
    arrayToProcess.forEach((element: any) => {
      let webBanner = {
        image: element.webImageFile,
        link: element.ctaLink,
        altTag: element.altTag
      }
      if (!element.isSmallBanner) {
        bannerList.push(webBanner);
      }
    });
    return bannerList;
  }

  onProductClick(data: any) {
    if (isPlatformBrowser(this.platformId)) {

    localStorage.setItem('source', 'Eshop');
  }
  }
  categoryClicked() {
    this.utils.eshopCatList.next(this.eshopHomeData && this.eshopHomeData.eShopCategoryList ? this.eshopHomeData.eShopCategoryList : []);
  }

  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}
